<template>
  <div>
    <div class="demand-hall-container">
      <com-header></com-header>
      <div class="demand-banner">
        <img src="../../assets/images/demand/banner.png" alt="" />
      </div>
      <div class="demand-option">
        <div class="tablist">
          <ul class="typelist">
            <li
              v-for="(tab, index) in demandType"
              :key="index"
              :class="[activeIndex === index ? 'active' : '']"
              @click="handleDemandType(index)"
            >
              {{ tab.title }}
            </li>
          </ul>
          <div class="release-btn" @click="release">发布需求</div>
        </div>
        <div class="line"></div>
        <div class="screen">
          <div
            :class="['public', activeSortIndex === 1 ? 'active' : '']"
            @click="handleSort('new')"
          >
            最新发布
          </div>
          <div
            :class="['public', activeSortIndex === 2 ? 'active' : '']"
            @click="handleSort('end')"
          >
            即将截止
          </div>
          <div class="address">
            地区：
            <check-address @checked="handleAddress"></check-address>
          </div>
        </div>
      </div>
      <div v-if="demandList.length > 0" class="demand-list">
        <!-- 找承包  -->
        <ul v-if="activeIndex === 0" class="demand">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-contract :source="item"></d-contract>
          </li>
        </ul>
        <!-- 找加工  -->
        <ul v-if="activeIndex === 1" class="demand">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-process :source="item"></d-process>
          </li>
        </ul>
        <!-- 找材料  -->
        <ul v-if="activeIndex === 2" class="demand">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-material :source="item"></d-material>
          </li>
        </ul>
        <!-- 找设计  -->
        <ul v-if="activeIndex === 3" class="demand">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-design :source="item"></d-design>
          </li>
        </ul>
        <!-- 找设备  -->
        <ul v-if="activeIndex === 4" class="demand">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-equipment :source="item"></d-equipment>
          </li>
        </ul>
        <!-- 找施工队 -->
        <ul v-if="activeIndex === 5" class="demand">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-working-team :source="item"></d-working-team>
          </li>
        </ul>
        <!-- 找工人 -->
        <ul v-if="activeIndex === 6" class="demand">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-worker :source="item"></d-worker>
          </li>
        </ul>
      </div>
      <div v-else class="noDataStyle">
        <div class="no-data">
          <img src="../../assets/images/no-data.png" />
        </div>
        <p>暂无数据</p>
      </div>

      <!-- 分页 -->
      <div class="pagging">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
          :accordion="true"
          :current-page="currentPageNum"
          :page-sizes="[9, 18, 27, 36]"
          :page-size="pageSizeActive"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <home-service></home-service>
    <com-footer></com-footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import checkAddress from '../../components/checkAddress'
// 找承包
import dContract from './component/dContract.vue'
// 找设计
import dDesign from './component/dDesign'
// 找设备
import dEquipment from './component/dEquipment'
// 找材料
import dMaterial from './component/dMaterial'
// 找加工
import dProcess from './component/dProcess'
// 找工人
import dWorker from './component/dWorker'
// 找施工队
import dWorkingTeam from './component/dWorkingTeam'
import homeService from '../../components/HomeService.vue'

export default {
  name: 'DemandHall',
  components: {
    checkAddress,
    dContract,
    dDesign,
    dEquipment,
    dMaterial,
    dProcess,
    dWorker,
    dWorkingTeam,
    homeService
  },
  data() {
    return {
      activeIndex: 0,
      demandList: [],
      total: 0,
      currentPageNum: 1,
      pageSizeActive: 9,
      activeSortIndex: 1,
      parameterData: {
        // 添加时间排序
        addtimeSort: 'Y',
        // 需求状态
        reqStatusList: [1]
      }
    }
  },
  computed: {
    ...mapState({
      demandType: (state) => state.demand.demandType,
      citys: (state) => state.enterprise.citys,
      province: (state) => state.enterprise.province
    })
  },
  created() {
    this.demandType.map((item, index) => {
      if (item.title === this.$route.query.name) {
        this.activeIndex = index
      }
    })

    this.queryDemand()
  },

  methods: {
    // 获取需求列表
    queryDemand() {
      this.demandList = []
      this.$http
        .post(
          `${this.initUrl()}${this.currentPageNum - 1}/${this.pageSizeActive}`,
          this.parameterData
        )
        .then((res) => {
          if (res.data.content.length > 0) {
            this.demandList = res.data.content
            this.total = res.data.totalElements
            // console.log(this.total)
            res.data.content.map((item) => {
              item.province = this.handleProvince(item.province)
              item.city = this.handleCity(item.city)
              item.district = this.handleArea(item.district)
            })
          }
        })
    },

    initUrl() {
      let reqUrl = ''
      switch (this.activeIndex) {
        // 找承包
        case 0:
          reqUrl = `/cms/reqContract/findReqSpecification/`
          break
        // 找加工
        case 1:
          reqUrl = `/cms/reqProcess/findReqSpecification/`
          break
        // 找材料
        case 2:
          reqUrl = `/cms/reqMaterial/findReqSpecification/`
          break
        // 找设计
        case 3:
          reqUrl = `/cms/reqDesign/findReqSpecification/`
          break
        // 找设备
        case 4:
          reqUrl = `/cms/reqEquipment/findReqSpecification/`
          break
        // 找施工队
        case 5:
          reqUrl = `/cms/reqConstructionTeam/findReqSpecification/`
          break
        // 找工人
        case 6:
          reqUrl = `/cms/reqEmployee/findReqSpecification/`
          break

        default:
          reqUrl = `/cms/reqContract/findReqSpecification/`
          break
      }
      return reqUrl
    },

    // 选择地址
    handleAddress() {
      this.parameterData.province = ''
      this.parameterData.citys = []

      if (this.province.length > 0) {
        let provinceId = this.province.map(
          (item) => this.$store.getters.handleProvinceId(item).code
        )
        console.log(provinceId)
        this.parameterData.province = provinceId.join() // 河北省
        this.parameterData.citys = []
      }
      if (this.citys.length > 0) {
        let cityId = this.citys.map(
          (item) => this.$store.getters.handleCityId(item).code
        )
        this.parameterData.citys = cityId
        this.parameterData.province = ''
      }

      this.currentPageNum = 1
      this.pageSizeActive = 9
      this.queryDemand()
    },

    // 选择需求类型
    handleDemandType(index) {
      this.activeIndex = index
      this.$router.push({
        path: '',
        query: {
          name: this.demandType[this.activeIndex].title
        }
      })
      this.queryDemand()
    },

    // 排序
    handleSort(val) {
      // 即将截止
      if (val === 'end') {
        delete this.parameterData.addtimeSort

        this.parameterData.nearingEnd = 'Y'
        this.activeSortIndex = 2
      } else {
        delete this.parameterData.nearingEnd
        // 最新发布 val: 'new'
        this.parameterData.addtimeSort = 'Y'
        this.activeSortIndex = 1
      }
      console.log(this.parameterData)
      this.queryDemand()
    },

    handleProvince(pid) {
      const data = this.$store.getters.handleProvince(pid)
      if (isNaN(parseInt(pid)) || data === undefined) return
      return data.name
    },

    handleCity(cid) {
      const data = this.$store.getters.handleCity(cid)
      if (isNaN(parseInt(cid)) || data === undefined) return
      return '/' + data.name
    },

    handleArea(aid) {
      const data = this.$store.getters.handleAre(aid)
      if (isNaN(parseInt(aid)) || data === undefined) return
      return '/' + data.name
    },

    // 发布需求
    release() {
      this.$router.push({
        path: `/release/${this.demandType[this.activeIndex].name}`
      })
    },

    // 需求详情
    demandDetail(item) {
      this.$router.push({
        path: `/demandDetail/${this.demandType[this.activeIndex].name}`,
        query: {
          id: item.reqGuid,
          from: 'hall',
          name: this.demandType[this.activeIndex].title
        }
      })
    },

    // pageSize每页条数改变时会触发
    handleSizeChange(val) {
      this.pageSizeActive = val
      this.queryDemand()
    },

    // currentPage 当前页改变时会触发
    handleCurrentChange(val) {
      this.currentPageNum = val
      this.queryDemand()
    }
  }
}
</script>

<style lang="scss" scoped>
.demand-hall-container {
  background: #f8f8f8;
  padding-bottom: 50px;
  .demand-banner {
    width: 1200px;
    height: 300px;
    margin: 0 auto;
    img {
      width: 100%;
      height: auto;
    }
  }
  .demand-option {
    width: 1200px;
    height: 110px;
    margin: 38px auto 0;
    padding: 0 20px;
    background: #ffffff;
    .tablist {
      padding-top: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 0 9px;
      ul.typelist {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        color: red;
        li {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          line-height: 22px;
          margin-right: 37px;
          cursor: pointer;
        }
        .active {
          font-size: 18px;
          color: #ce2939;
          line-height: 25px;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -12px;
            width: 20px;
            height: 3px;
            background: #ce2939;
            border-radius: 2px;
          }
        }
      }
      .release-btn {
        width: 100px;
        height: 30px;
        background: #ce2939;
        border-radius: 2px;
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
        line-height: 28px;
        cursor: pointer;
        text-align: center;
      }
    }

    .line {
      width: 1157px;
      height: 1px;
      margin: 0 auto;
      background: #e3e3e3;
    }
    .screen {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 15px;
      .public {
        font-size: 14px;
        line-height: 20px;
        margin-right: 44px;
        color: #666666;
        cursor: pointer;
      }
      .active {
        font-size: 14px;
        color: #ce2939;
        line-height: 20px;
      }
      .address {
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
      .active {
        color: #ce2939;
      }
    }
  }
  .demand-list {
    width: 1200px;
    min-height: 500px;
    margin: 30px auto 0;
    ul.demand {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      li.demand-item {
        width: 374px;
        height: 140px;
        overflow: hidden;
        background: #ffffff;
        margin-bottom: 40px;
        border: 1px solid #e7e7e7;
        margin-right: 39px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        &:hover {
          box-shadow: 0px 2px 10px 2px rgba(227, 0, 49, 0.12);
          border-radius: 2px;
          border: 1px solid #ce2939;
        }
      }
    }
  }

  .noDataStyle {
    width: 1200px;
    height: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    color: #999999;
    text-align: center;
    background: #ffffff;
    .no-data {
      width: 70px;
      height: 80px;
      margin: 0 auto 30px;
      overflow: hidden;
      img {
        // margin-top: 120px;
        width: 100%;
      }
    }
    p {
      font-size: 16px;
      color: #666666;
    }
  }
  .pagging {
    width: 1200px;
    margin: 0 auto;
    text-align: right;
  }
}
</style>

<style>
.demand-hall-container
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #d21d26;
}
</style>
